import React from "react";
import { Button, Checkbox, Icon, Image, Menu, Modal } from "semantic-ui-react";
import { Link, useLocation } from "react-router-dom";

const MenuLayout = props => {
  // localStorage 직접 평가는 React state 가 아니라 변경 감지 못 함.
  // MenuContainer 가 redux state 구독 후 props 로 내려준다.
  const {
    isLoggedIn,
    isAdmin,
    cartEnabled,
    cartKnown,
    cartBusy,
    onToggleCart,
    pushSupported,
    pushSubscribed,
    pushPermission,
    pushBusy,
    onTogglePush,
    showInstall,
    onInstallClick,
    iosHintOpen,
    onCloseIosHint
  } = props;

  // 알림 토글 노출 조건: 로그인 + 브라우저 지원 + 권한이 'denied' 가 아님
  // (denied 면 브라우저 설정에서 직접 풀어야 해서 토글로는 못 켬).
  const showPushToggle =
    isLoggedIn && pushSupported && pushPermission !== "denied";

  // 현재 경로 기반 active 표시. '/' 는 exact match (하위 경로와 겹치지 않게).
  const { pathname } = useLocation();

  return (
    <div>
      <Menu fixed="top" inverted className="dbrs-top-menu">
        <Menu.Item
          header
          key="menuHeader"
          as={Link}
          to="/"
        >
          <Image
            size="mini"
            src="/images/footer-logo.png"
            style={{ marginRight: "1.5em" }}
          />
        </Menu.Item>
        {isLoggedIn ? (
          <Menu.Item key={"menu"} as={Link} to="/" active={pathname === "/"}>
            신청현황
          </Menu.Item>
        ) : null}
        {isLoggedIn ? (
          <Menu.Item
            key={"multiMenu"}
            as={Link}
            to="/bookMultiRequest"
            active={pathname === "/bookMultiRequest"}
          >
            도서 신청
          </Menu.Item>
        ) : null}
        {/* 보관함(베타) 켠 계정만 노출. on/off 토글은 우측 아이콘 버튼(종·다운로드 옆). */}
        {isLoggedIn && cartKnown && cartEnabled ? (
          <Menu.Item
            key={"cartMenu"}
            as={Link}
            to="/cart"
            active={pathname === "/cart"}
          >
            보관함
          </Menu.Item>
        ) : null}
        {isLoggedIn && isAdmin ? (
          <Menu.Item
            key={"adminMenu"}
            as={Link}
            to="/admin/users"
            active={pathname === "/admin/users"}
          >
            회원관리
          </Menu.Item>
        ) : null}
        <Menu.Item position="right" key={"rightSection"} className="dbrs-top-menu-right">
          {isLoggedIn ? (
            <div style={{ display: "flex", gap: 4, flexWrap: "nowrap" }}>
              {showInstall ? (
                <Button
                  size="small"
                  inverted={false}
                  onClick={onInstallClick}
                  className="dbrs-menu-btn"
                  title="앱 설치"
                >
                  <Icon name="download" style={{ marginRight: 0 }} />
                </Button>
              ) : null}
              {showPushToggle ? (
                <Button
                  size="small"
                  inverted={false}
                  color={pushSubscribed ? "green" : undefined}
                  loading={!!pushBusy}
                  onClick={onTogglePush}
                  className="dbrs-menu-btn"
                  title={pushSubscribed ? "알림 끄기" : "알림 켜기"}
                >
                  <Icon name={pushSubscribed ? "bell" : "bell outline"} style={{ marginRight: 0 }} />
                </Button>
              ) : null}
              {/* 보관함 베타 on/off — 처음 보는 사람도 알 수 있게 '보관함' 라벨 + 토글 스위치.
                  기본 꺼짐(계정 CART_BETA_YN='N'). 서버 값 조회 후(cartKnown)에만 노출. */}
              {cartKnown ? (
                <div
                  className="dbrs-menu-btn dbrs-cart-toggle"
                  style={{ display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}
                  title={cartEnabled ? "보관함 기능 끄기 (베타)" : "보관함 기능 켜기 (베타)"}
                >
                  <span style={{ color: "#fff", fontSize: "0.9em" }}>보관함</span>
                  <Checkbox
                    toggle
                    checked={cartEnabled}
                    disabled={!!cartBusy}
                    onChange={onToggleCart}
                  />
                </div>
              ) : null}
              <Button
                primary
                size="small"
                inverted={false}
                onClick={props.onButtonClickForModifyMember}
                className="dbrs-menu-btn"
              >
                회원정보 수정
              </Button>
              <Button
                size="small"
                inverted={false}
                onClick={props.onButtonClick}
                className="dbrs-menu-btn"
              >
                로그아웃
              </Button>
            </div>
          ) : null}
        </Menu.Item>
      </Menu>

      {/* iOS 사용자가 설치 버튼 누르면 안내 모달 — Safari 가 자동 install prompt 를 안 띄움. */}
      <Modal open={!!iosHintOpen} onClose={onCloseIosHint} size="tiny" closeIcon>
        <Modal.Header>홈 화면에 추가하기 (iPhone)</Modal.Header>
        <Modal.Content>
          <p>iPhone Safari 는 자동 설치가 안 됩니다. 아래 순서대로 직접 설치해 주세요.</p>
          <ol style={{ paddingLeft: "1.2em" }}>
            <li>화면 하단의 <b>공유 버튼</b> (네모에 화살표 ↑) 을 누릅니다.</li>
            <li>메뉴를 내려서 <b>"홈 화면에 추가"</b> 항목을 선택합니다.</li>
            <li><b>"추가"</b> 를 눌러 홈 화면에 DBRS 아이콘이 생기면 완료.</li>
          </ol>
          <p style={{ marginTop: "1em", color: "#888", fontSize: "0.9em" }}>
            ※ 홈 화면 아이콘으로 열어야 알림(푸시) 기능이 동작합니다.
          </p>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onCloseIosHint}>확인</Button>
        </Modal.Actions>
      </Modal>

      {/* 모바일에서 우측 버튼이 viewport 밖으로 밀려 잘리던 문제 fix.
          좁은 화면에선 좌측 헤더(로고) 의 좌측 padding 축소 + 우측 패딩 0 + 버튼 padding 축소. */}
      <style>{`
        /* 보관함 베타 토글 — 켜짐 색을 앱 강조색(초록)으로 */
        .dbrs-cart-toggle .ui.toggle.checkbox input:checked ~ .box:before,
        .dbrs-cart-toggle .ui.toggle.checkbox input:checked ~ label:before {
          background-color: #21ba45 !important;
        }
        /* 모바일에서 상단 메뉴 item / 버튼 잘림 방지 — padding 축소 + 폰트 축소 */
        @media (max-width: 768px) {
          .dbrs-top-menu .header { padding-left: 0.5em !important; padding-right: 0.5em !important; }
          .dbrs-top-menu .item { padding-left: 0.45em !important; padding-right: 0.45em !important; font-size: 0.88em !important; }
          .dbrs-top-menu-right { padding-right: 0.4em !important; }
          .dbrs-menu-btn { padding: 0.5em 0.7em !important; font-size: 0.85em !important; }
        }
        @media (max-width: 480px) {
          .dbrs-top-menu .header img { display: none; }
          .dbrs-top-menu .item { padding-left: 0.3em !important; padding-right: 0.3em !important; font-size: 0.78em !important; }
          .dbrs-menu-btn { padding: 0.4em 0.5em !important; font-size: 0.72em !important; }
        }
      `}</style>
    </div>
  );
};

export default MenuLayout;
